import script from "./ResumeView.vue?vue&type=script&setup=true&lang=js"
export * from "./ResumeView.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__